const faqData = [
  {
    q: '青青草视频是什么？和普通视频网站有什么不同？',
    a: '青青草视频是一个影视平台聚合导航站，我们整合了香蕉视频、红桃视频、91视频、蜜桃视频等多家热门影视平台的信息与入口。与普通视频网站不同，青青草视频本身不存储视频内容，而是帮您发现、了解和选择最适合的影视平台。',
  },
  {
    q: '青青草视频上的平台都是免费的吗？',
    a: '我们聚合的影视平台多数提供免费在线观看服务，部分平台设有会员专属内容或高清专区。每个平台的具体收费策略不同，建议您在各平台官网查看详细说明。青青草视频本身完全免费，不向用户收取任何费用。',
  },
  {
    q: '为什么推荐同时使用多个影视平台？',
    a: '不同平台在内容储备、更新频率、播放技术和用户体验方面各有优势。比如香蕉视频内容最丰富，红桃视频原创最强，蜜桃视频播放最流畅。多平台搭配使用，可以获得更全面的观影体验。',
  },
  {
    q: '播放不缓冲是真的吗？需要什么网络条件？',
    a: '蜜桃视频等平台采用了先进的CDN加速和自适应码率技术，在4G网络或普通WiFi环境下即可流畅播放。当然，稳定的网络连接是良好体验的基础。如果遇到缓冲问题，建议检查网络或切换到其他平台试试。',
  },
  {
    q: '排名数据是如何产生的？多久更新一次？',
    a: '热门排行综合了用户访问热度、内容更新频率、播放体验评分和社区口碑等多个维度，由系统每日自动更新。排名结果仅供用户参考，不构成任何商业推荐或投资建议。',
  },
  {
    q: '我是影视平台方，如何接入青青草视频？',
    a: '欢迎优质影视平台与我们合作！请通过本页面的"联系我们"模块提交您的平台信息与合作意向，我们的运营团队会在1-2个工作日内与您联系，评估接入事宜。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于平台使用、功能与合作的常见问题解答，帮助您快速了解青青草视频
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 gap-3">
            {faqData.map((item, idx) => (
              <details
                key={idx}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between px-5 py-4 list-none">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.q}
                  </h3>
                  <div className="w-6 h-6 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 transition-transform group-open:rotate-180 text-sm"></i>
                  </div>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}